
import { PunkParsedGameData } from "../../../server/data/PunkParsedGameData";
import { PosterManager, PosterStates } from "../../independent/Poster/PosterManager";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { StateSymbolWin } from "../../independent/symbol/StateSymbolWin";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { TimelineLite, TweenLite } from "gsap";
import { JumpingWildController, JumpWildState } from "../../independent/jumpingWild/JumpingWildController";
import { PunkGameModuleConfig } from "../../../PunkGameModuleConfig";
import { ReelAnimationManager } from "../../independent/reelAnimator/ReelAnimationManager";
import { SoundConfig } from "../../../SoundConfig";
import { Point } from "pixi.js";
import { AnimationEffects } from "../../../effects/AnimationEffects";
import { ReelSlicedDivider } from "../../independent/divider/ReelSlicedDivider";
import { ReelGraphicBackground } from "../../independent/background/ReelGraphicBackground";
import { SplashController } from "../../independent/splashScreen/SplashController";
import { ReelItemOverlay, ReelOverlayState } from "../../independent/overlay/ReelItemOverlay";
import { TrainState  } from "../../independent/countup/XWaysCounter";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { PunkSymbolData } from "../../../punkEngine/config/PunkSymbolData";
import { ReelSymbolName } from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import { PunkSymbol } from "../../../punkEngine/PunkSymbol";

class BonusIntroState extends StateHandler{
    public static readonly BONUS_HITS:string = "bonus_hits";
    public static readonly POSTING:string = "posting";
    public static readonly SWITCH_SYMBOL:string = "switch_symbols";
    public static readonly transform:string = "transform";

    public static readonly TRAIN:string = "train";
    public static readonly ENABLE_BUTTON:string = "enable_button";
    public static readonly JUMP_WILDS:string = "jump_wilds";
    public static readonly DONE:string = "done";
}

export class BonusIntroPresentation extends Presentation {

    protected scatterPositions:number[];
    protected _wildPositions:number[];

    protected scatterAmount:number;

    protected isRespin:boolean = false;
    protected _nowin:boolean = false;

    protected state:BonusIntroState = new BonusIntroState(PresentationState.INACTIVE);

    protected _expandingMultiplyValues:number[];

    public setParsedGamedData(data:PunkParsedGameData):void{
        this.scatterPositions = data.scatterReelPositions;
        this.scatterAmount = data.scatterLandAmount;
        
        this._nowin = data.singleWin == 0;

        this._wildPositions = data.wildLandPositions;

        PunkGameModuleConfig.xWayCounter.UpdateFreeSpinCounter(7);

        this.state.set(BonusIntroState.BONUS_HITS);
        this.isRespin = data.nextMode == GameMode.RESPIN;

        PunkGameModuleConfig.xWayCounter.setTrainItems(["X25","SPIN1","MFS","WJ","FULL","X1"]);

        this._expandingMultiplyValues = this.calculateMultiWaysValues(data);
    }

    private calculateMultiWaysValues(data:PunkParsedGameData):number[]{
        const temp:number[] = [];
        if(data.mysteryData){
            const nrOfReels:number = PunkEngineManager.AllReels.length;
            let calcValues:number[] = ArrayHelper.initArrayWithValues(nrOfReels,() => 3)
            calcValues[0] = data.gameAreaSize[0];

            for(let reel:number = 0; reel < nrOfReels; reel++){
                let total:number = calcValues[0];
                calcValues[reel] = data.gameAreaSize[reel];
                for(let i:number = 1; i < calcValues.length; i++){
                    total *= calcValues[i];
                }
                temp.push(total);
            }
        }
        return temp;
    }

    public checkForActivation(data:PunkParsedGameData):boolean{ return this.isNextBonus(data)};

    private isNextBonus(data:PunkParsedGameData):boolean{ return (data.nextMode !== GameMode.NORMAL && data.mode === GameMode.NORMAL); }

    public getPresentation(){
        switch(this.state.state){
            case BonusIntroState.BONUS_HITS:
                this.showBonuHits();
                this.state.set(BonusIntroState.POSTING);
                break;
            case BonusIntroState.POSTING:
                this.ReelBoom();
                this.state.set(this.isRespin ? BonusIntroState.SWITCH_SYMBOL : BonusIntroState.TRAIN);
                break;
            case BonusIntroState.SWITCH_SYMBOL: // RESPIN
                this.SwitchSymbol();
                this.state.set(BonusIntroState.transform)
                break;
            case BonusIntroState.transform:
                this.transformSymbols();
                this.state.set(BonusIntroState.DONE)
                break;
            case BonusIntroState.TRAIN: // FS
                this.trainArrives();
                // This will turn off Autoplay if in restricted jurisdiction
                if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
                    SlotGame.autoPlay.turnOffAutoplayOnBonus();
                }
                this.state.set(BonusIntroState.ENABLE_BUTTON);
                break;
            case BonusIntroState.ENABLE_BUTTON: 
                this.buttonScreen();
                break;
            default:
                this.PresentationState.set(PresentationState.END);
                break;
        }
    }
    
    protected trainArrives():void{

        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.setVisible(false,0.2), 0);
        this.pTimeline.add(() => JumpingWildController.instance.ChangeToSpine(),0);

        this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.TRAIN_BRAKE));
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainState(TrainState.INTRO), 0);
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.trainState(TrainState.OPEN_CLOSE), this.pTimeline.totalDuration() +  TrainState.getDuration(TrainState.INTRO));
        this.pTimeline.add(() => PunkGameModuleConfig.xWayCounter.showTrainItems(true, [0,1,2,3,4,5], 0.3),this.pTimeline.totalDuration() +  TrainState.getDuration(TrainState.OPEN_CLOSE)-0.15);
        this.pTimeline.to(this,0.3,{});
        this.pTimeline.add(() =>  PosterManager.instance.playSirene(false));
        this.pTimeline.add(() =>  PunkGameModuleConfig.xWayCounter.counterActive(false));
    }

    protected showBonuHits():void{
        let delay:number = 0.1;
        const nextAnim:number = 0.05;

        SoundManager.playSoundEffect(SoundConfig.instance.BLACK_SWIPE);
        for(let reel:number = 0; reel < PunkEngineManager.AllReels.length-1;reel++){
            if(this.scatterPositions[reel] >= 0){
                this.pTimeline.add([
                    StateSymbolWin.instance.playFrameAnimation({
                        ReelID: reel,
                        SymID: this.scatterPositions[reel],
                        State:ReelSymbolStates.TRANSFORM,
                        duration: 0.6,
                    }),
                    () => PunkEngineManager.getReel(reel).getSymbol(this.scatterPositions[reel])!.changeState({ state: ReelSymbolStates.IDLE }),
                ],delay)
            }
            for(let row:number = 0; row < PunkEngineManager.getReel(reel).AllWindowSymbols.length;row++){
                const symPos:number = PunkEngineManager.getReel(reel).AllWindowSymbols[row].posID;
                this.pTimeline.add(() => PunkEngineManager.getReel(reel).getSymbol(symPos)!.attentionDarkness(1,0),delay)
                this.pTimeline.add(() => PunkEngineManager.getReel(reel).getSymbol(symPos)!.attentionDarkness(0,0.5),delay+nextAnim)
            }
            delay += nextAnim;
        }
      
        delay -= nextAnim;
        ReelSlicedDivider.instance.fadeOutAndRemove(ReelAnimationManager.bonusReelID);
        this.pTimeline.add([
            AnimationEffects.Shake({
            x:0.4,
            y:1,
            obj: ReelAnimationManager.bonusReel,
            duration:1,
            Intensity:6,
            positionCb: () => { 
                const posOffsetY:Point = MathHelper.pointAdd(<Point>PunkEngineManager.getReel(5).position, new Point(0,PunkEngineManager.getReel(5).scale.y * PunkSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT));
                return posOffsetY;
             },
            hertz:100
            }),
            () => SoundManager.playSoundEffect(SoundConfig.instance.FENCE_EXPLODE),
        ],delay);

        this.pTimeline.add([
            () => ReelAnimationManager.bonusReel.killLoop(),
            () => ReelAnimationManager.bonusReel.playBoom(),
            () => PunkGameModuleConfig.xWayCounter.setValue(undefined, this._expandingMultiplyValues[this._expandingMultiplyValues.length-1],0.5)
        ],"-=" + 0.25);
        const boomReelID:number = ReelAnimationManager.bonusReel.ReelID;
        for(let row = 0; row < PunkEngineManager.getReel(boomReelID).AllSymbols.length; row++){
            this.pTimeline.add(() => PunkEngineManager.getReel(boomReelID).AllSymbols[row].setSuperVisibility(false));
        }
        if(this.isRespin) this.pTimeline.add(() => SoundManager.playRespin(),0);
        
        this.pTimeline.to(this,0.5,{});
    }

    protected SwitchSymbol():void{
        let jwIndx:number = 0;
        this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_MOVES),0);
        for(let reel = 0; reel < this.scatterPositions.length; reel++){
            if(this.scatterPositions[reel] == -1) continue;
            this.pTimeline.add(JumpingWildController.instance.JumpTo({
                ID: jwIndx,
                to:{reel: reel, row: this.scatterPositions[reel]},
                duration:0.6,
                state: JumpWildState.WIN
            }),0)
            jwIndx++;

            this.pTimeline.add([
                () => JumpingWildController.instance.HideSkulls(0.6),
                () => StateSymbolWin.instance.playFrameAnimation({
                    ReelID: reel,
                    SymID: this.scatterPositions[reel],
                    State:ReelSymbolStates.TRANSFORM,
                    duration: 0.6,
                }),
                () => PunkEngineManager.getReel(reel).getSymbol(this.scatterPositions[reel])!.changeState({
                    state: ReelSymbolStates.TRANSFORM,
                    duration: 0.6,
                    newSym: "W"
                }),
            ],0.6);
        }
    }
    
    protected transformSymbols():void{
        const transformDurr:number = MathHelper.frameToSeconds(15);
        let startTime:number = this.pTimeline.totalDuration();
        let transformDelay:number = startTime;

        const tl:TimelineLite = new TimelineLite();

        playExpandingFromArray(this.scatterPositions);
        // playExpandingFromArray(this._wildPositions);

        this.pTimeline.add(tl);

        startTime = this.pTimeline.totalDuration()-transformDurr*0.5;
        for(let reel:number = 0; reel < PunkEngineManager.AllReels.length-1;reel++){
            if(!PunkEngineManager.getReel(reel).isActive){
                this.pTimeline.add(ReelAnimationManager.getReelArea(reel).chainsActive(true), startTime);
                this.pTimeline.add( () => SoundManager.playSoundEffect([SoundConfig.instance.CHAIN1,SoundConfig.instance.CHAIN2][reel%2]), startTime)
                startTime += 0.3;
            }

        }

        function playExpandingFromArray(arr:number[]):void {
            for(let reel:number = 0; reel < arr.length;reel++){
                transformDelay = startTime;
                const firstSymbol:PunkSymbol = PunkEngineManager.getReel(reel).getSymbol(arr[reel])!;
                if(firstSymbol.isWild) firstSymbol.setActive(true);
                
                let soundCount:number = 0;
                for(let row:number = arr[reel]-1; row >= 0 ; row --){
                    const symbol:PunkSymbol = PunkEngineManager.getReel(reel).getSymbol(row)!;
                    symbol.setActive(true);
                    if(symbol.isWild) continue;
                    tl.add(symbol.changeState({
                        state: ReelSymbolStates.TRANSFORM,
                        forceState:true,
                        newSym: ReelSymbolName.WILD,
                        duration: transformDurr
                    }),transformDelay);
                    const soundType:string = soundCount == 0 ? SoundConfig.instance.WILD_EXPANDS_1 :SoundConfig.instance.WILD_EXPANDS_2;
                    tl.add(() => SoundManager.playSoundEffect(soundType),transformDelay);
                    tl.add(ReelItemOverlay.instance.playAnimation(reel,row+1,ReelOverlayState.IGNITE),transformDelay);
                    tl.add(ReelItemOverlay.instance.playAnimation(reel,row,ReelOverlayState.FIRE),transformDelay + MathHelper.frameToSeconds(5));
                    transformDelay += MathHelper.frameToSeconds(10);
                    soundCount++;
                }
                if(arr[reel]-1 >= 0){
                    startTime += 0.1;
                }
            }
        }
    }

    protected ReelBoom():void{
        if(!this.isRespin){
            this.pTimeline.add([
                PosterManager.instance.playPoster(this.scatterAmount == 3 ? PosterStates.BONUS : PosterStates.BONUS2),
                () => SoundManager.playSoundEffect(SoundConfig.instance.FS_INTRO),
                () =>  PosterManager.instance.playSirene(true, 0),
            ]);
        }
        for(let reel = 0; reel < this.scatterPositions.length; reel++){
            if(this.scatterPositions[reel] == -1) continue;
            JumpingWildController.instance.createJumpWilds(reel, 0);
        }
        this.pTimeline.add([
            () => ReelAnimationManager.bonusReel.removeSkulls(false),
            () => JumpingWildController.instance.StartShow()
        ]);

        this.pTimeline.add(() => ReelAnimationManager.bonusReel.setActiveReel(true))
        this.pTimeline.to(this,0.2,{});
    }

    protected startJump():void{
        this.pTimeline.fromTo(ReelGraphicBackground.instance,0.3,{alpha:0.45 },{alpha:0});
        let jwIndx:number = 0;
        this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.WILD_MOVES),0.6);
        for(let reel = 0; reel < this.scatterPositions.length; reel++){
            if(this.scatterPositions[reel] == -1) continue;
            this.pTimeline.add(JumpingWildController.instance.JumpTo({
                ID: jwIndx,
                to:{reel: reel, row: this.scatterPositions[reel]},
                duration:0.6,
                state: JumpWildState.WIN
            }),0.6)
            jwIndx++;
        }
    }

    protected buttonScreen():void{
        // SlotGame.keypad.hide();
        this.pTimeline.fromTo(ReelGraphicBackground.instance,0.3,{alpha:0 },{alpha:0.45});
        this.pTimeline.add(() => this.state.set(BonusIntroState.JUMP_WILDS));
        this.pTimeline.add(SplashController.instance.Play());
    }

    public endPresentation():void{
        if(this.isRespin) PunkGameModuleConfig.xWayCounter.setValue(undefined, Math.pow(3,6),0.5);
        this.PresentationState.set(PresentationState.INACTIVE);
    }

    public skipPresentation():void{
        if(this.state.equal(BonusIntroState.JUMP_WILDS)){
            TweenLite.fromTo(ReelGraphicBackground.instance,0.3,{alpha:0.45 },{alpha:0});
            SoundManager.playBonus();
            SlotGame.keypad.setZeroBetSpinCounter(8);
            SplashController.instance.stop()
            this.state.set(BonusIntroState.DONE);
            this.pTimeline.totalProgress(1);
        } 
    }
}